import { Component, Input, OnInit } from '@angular/core';
import { CrudOrgInvitesFacade } from './crud-org-invites.facade';
import { COMMON_IMPORTS } from '../../global-misc/common-imports';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { DialogModule } from 'primeng/dialog'; // For confirmation dialogs
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-crud-org-invites',
  imports: [...COMMON_IMPORTS, ButtonModule, InputTextModule, DropdownModule, TableModule, TagModule, DialogModule, TooltipModule],
  templateUrl: './crud-org-invites.component.html'
})
export class CrudOrgInvitesComponent implements OnInit {
  @Input() orgId!: string;
  uiState$ = this.facade.uiState$;

  showAddInviteDialog = false; // To control the new Add Invite dialog

  // For confirmation dialogs
  showRevokeConfirmDialog = false;
  pendingRevokeInviteId: string | null = null;
  pendingRevokeInviteEmail: string | null = null;

  constructor(public facade: CrudOrgInvitesFacade) { }

  ngOnInit() {
    if (this.orgId) {
      this.facade.load(this.orgId);
    }
  }

  openAddInviteDialog() {
    // Potentially reset form if needed when opening
    // this.facade.resetAddInviteForm(); // Assuming facade has a method to get a clean form state or reset it
    this.showAddInviteDialog = true;
  }

  closeAddInviteDialog() {
    this.showAddInviteDialog = false;
  }

  onAddInvite(form: any) {
    // Use 'any' for form group passed from template
    this.facade.createInvite(form).then(() => {
      // Assuming createInvite is async and we want to close the dialog on success
      const currentState = this.facade.getCurrentUiState(); // Need a way to check if invite was successful
      if (currentState && !currentState.error) {
        // Check if there's no error after attempting to create
        this.closeAddInviteDialog();
      }
    });
  }

  onResendInvite(inviteId: string) {
    this.facade.resendInvite(inviteId);
  }

  // Revoke confirmation handling
  onRevokeInvite(inviteId: string, email: string) {
    this.pendingRevokeInviteId = inviteId;
    this.pendingRevokeInviteEmail = email;
    this.showRevokeConfirmDialog = true;
  }

  confirmRevoke() {
    if (this.pendingRevokeInviteId) {
      this.facade.revokeInvite(this.pendingRevokeInviteId);
    }
    this.closeRevokeDialog();
  }

  cancelRevoke() {
    this.closeRevokeDialog();
  }

  private closeRevokeDialog() {
    this.showRevokeConfirmDialog = false;
    this.pendingRevokeInviteId = null;
    this.pendingRevokeInviteEmail = null;
  }
}
